import {useContext,} from 'react';
import {Card, Field} from '../../../../layouts';
import {QuoteTypes} from '../../../../types/enums';
import {formatShortDate, formatShortDateShortTime} from '../../../../utils/date-utils';
import {EstimateContext} from '../context/EstimateContext';

export default function EstimateInformationCard() {

	const { order } = useContext(EstimateContext);

	const isLead = order.details.quoteTypeID === QuoteTypes.Lead;

	return (
		<>
			<Card
				header={isLead ? 'Lead Information' : 'Estimate Information'}
				className="estimate-information-card"
			>
				<Field label={isLead ? 'Lead #' : 'Estimate #'} >{order.details.quoteNumber}</Field>
				<Field label={'Status'} >{order.details.status}</Field>
				<Field label={'IME Status'} >{order.details.imeStatus}</Field>
				<Field label={isLead ? 'Lead Date' : 'Estimate Date'} >{formatShortDate(order.details.quoteDate)}</Field>
				<Field label={isLead ? 'Lead Creation Date' : 'Estimate Creation Date'} >{formatShortDateShortTime(order.details.createdOn)}</Field>
			</Card>
		</>
	);
}
